import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import {
    Card,
    CardBody,
    Table,
    Col,
    Input,
    Button,
    CardTitle,
    CardHeader,
    CardFooter,
    Label,
    InputGroup,
    InputGroupAddon
} from "reactstrap";

import OrderDetail from "../components/Childrens/OrderDetails.v3"
import OrderCreate from "../components/Childrens/OrderCreate"
import OrderExtend from "../components/Childrens/OrderExtend"
import OrderService from "../services/order.service"
import Select from 'react-select';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from 'moment'

function Orders() {
    const history = useHistory();
    const location = useLocation();
    const [orders, setOrders] = useState([])
    const [page, setPage] = useState('')
    const [dataProps, setDataProps] = useState([])
    const [search, setSearch] = useState("")
    const [pageOrder, setPageOrder] = useState(1)
    const [showLoadTruoc, setShowLoadTruoc] = useState(false)
    const [showLoadSau, setShowLoadSau] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    // Biến để theo dõi việc đã cập nhật URL chưa
    const hasUpdatedUrl = useRef(false);

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
    })

    // Khởi tạo trang dựa trên localStorage hoặc URL
    useEffect(() => {
        // Khởi tạo pageOrder từ localStorage hoặc URL
        let initialPage = 1; // Mặc định là trang 1

        // Kiểm tra localStorage trước (ưu tiên cao hơn)
        const savedPage = localStorage.getItem('orderListPage');
        if (savedPage && !isNaN(parseInt(savedPage))) {
            initialPage = parseInt(savedPage);
            localStorage.removeItem('orderListPage'); // Xóa ngay để tránh ảnh hưởng lần sau
        } else {
            // Nếu không có localStorage, kiểm tra URL
            const queryParams = new URLSearchParams(location.search);
            const pageParam = queryParams.get('page');
            if (pageParam && !isNaN(parseInt(pageParam))) {
                initialPage = parseInt(pageParam);
            }
        }

        // Cập nhật pageOrder
        if (initialPage !== pageOrder) {
            setPageOrder(initialPage);
        } else {
            // Nếu pageOrder không thay đổi, vẫn cần tải dữ liệu (trường hợp page=1)
            fetchOrders(initialPage);
        }
    }, []);

    // Cập nhật URL và tải dữ liệu khi pageOrder thay đổi
    useEffect(() => {
        // Cập nhật URL
        updateUrlWithPage();

        // Tải dữ liệu
        fetchOrders(pageOrder);
    }, [pageOrder]);

    // Cập nhật URL với tham số trang
    const updateUrlWithPage = () => {
        const queryParams = new URLSearchParams(location.search);
        queryParams.set('page', pageOrder);

        // Chỉ cập nhật URL nếu cần thiết
        const newSearch = queryParams.toString();
        if (location.search !== `?${newSearch}`) {
            history.push({
                pathname: location.pathname,
                search: newSearch
            });
        }
    };

    const fetchOrders = async (page = pageOrder) => {
        try {
            setIsLoading(true);

            // Gọi API với trang được chỉ định
            console.log(`Đang tải dữ liệu cho trang ${page}`);
            let result = await OrderService.getAllOrder(page, search);

            if (result && result.orders) {
                setOrders(result.orders);
            } else {
                console.error("Không nhận được dữ liệu đơn hàng hoặc định dạng không đúng:", result);
                Swal.fire({
                    icon: 'error',
                    title: 'Lỗi',
                    text: 'Không thể tải dữ liệu đơn hàng',
                    timer: 1500
                });
            }

            // Đảm bảo reset các spinner sau khi tải xong
            setShowLoadTruoc(false);
            setShowLoadSau(false);
            setIsLoading(false);
        } catch (error) {
            console.error("Lỗi khi tải dữ liệu đơn hàng:", error);
            Swal.fire({
                icon: 'error',
                title: 'Lỗi',
                text: 'Không thể tải dữ liệu đơn hàng',
                timer: 1500
            });
            // Reset các spinner khi có lỗi
            setShowLoadTruoc(false);
            setShowLoadSau(false);
            setIsLoading(false);
        }
    }

    function searchSpace(event) {
        let keyword = event.target.value;
        setSearch(keyword);
    }

    async function handleSearch() {
        // Đặt lại về trang 1 khi tìm kiếm
        setPageOrder(1);

        // Thực hiện tìm kiếm sau khi đã cập nhật pageOrder
        await fetchOrders(1);

        // Cập nhật URL khi tìm kiếm
        const queryParams = new URLSearchParams(location.search);
        queryParams.set('page', 1);
        if (search.trim()) {
            queryParams.set('search', search);
        } else {
            queryParams.delete('search');
        }
        history.push({
            pathname: location.pathname,
            search: queryParams.toString()
        });
    }

    // Hiển thị hiệu ứng loading ở giữa trang
    const renderLoading = () => (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px", width: "100%" }}>
            <div className="text-center">
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="sr-only">Đang tải...</span>
                </div>
            </div>
        </div>
    );

    function table() {
        return (
            <Table className="table-hover" style={{ lineHeight: "15px" }}>
                <thead className="text-primary">
                    <tr>
                        <th>ID</th>
                        <th className="table-device-mobile">Email</th>
                        <th className="table-device-mobile">Họ tên</th>
                        <th className="table-device-mobile">Hành động</th>
                        <th className="table-device-mobile">Phần mềm</th>
                        <th className="table-device-mobile">Chi tiết</th>
                        <th>Tổng tiền</th>
                        <th className="table-device-mobile">Phương thức</th>
                        <th className="table-device-mobile">Trạng thái</th>
                        <th className="table-device-mobile">KiotViet</th>
                        <th>Thời gian</th>
                    </tr>
                </thead>
                <tbody>
                    {loadFillData()}
                </tbody>
            </Table>
        )
    }

    function toDetailView(val) {
        // Lưu trữ trang hiện tại vào localStorage trước khi chuyển hướng
        localStorage.setItem('orderListPage', pageOrder);
        history.push(`/orders-id/${val.id}`);
    }

    function loadFillData() {
        return orders?.map((data, key) => {
            let color = "";
            if (data.paymentStatus === "Đã thanh toán") color = "table-success";
            if (data.paymentStatus === "Chưa thanh toán") color = "table-warning";
            if (data.paymentStatus === "Đã hủy" || data.paymentStatus === "Đã hết hạn") color = "table-danger";

            return (
                <tr className={color} onClick={() => toDetailView(data)} style={{ cursor: "pointer" }} key={key}>
                    <th>{data.id}</th>
                    <td className="table-device-mobile">{data.email}</td>
                    <td className="table-device-mobile">{data.fullName}</td>
                    <td className="table-device-mobile">{data.actionString}</td>
                    <td className="table-device-mobile">{data.toolName}</td>
                    <td className="table-device-mobile">{data.attributeString}</td>
                    <td>{new Intl.NumberFormat('vi-VN').format(data.totalPrice)} đ</td>
                    <td className="table-device-mobile">{data.paymentMethod}</td>
                    <td className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>{data.paymentStatus}</td>
                    <td className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>
                        {data.syncKiot ? (
                            <span style={{ backgroundColor: '#28a745', color: '#fff', padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold' }}>Đã sync</span>
                        ) : (
                            <span style={{ backgroundColor: '#ff9800', color: '#fff', padding: '4px 10px', borderRadius: '12px', fontSize: '11px' }}>Chưa sync</span>
                        )}
                    </td>
                    <td>{moment(data.createdAt).format('HH:mm DD/MM')}</td>
                </tr>
            )
        });
    };

    function back() {
        return (
            <Button
                color="info"
                onClick={() => setPage('')}>
                &laquo; Quay lại
            </Button>
        )
    }

    function changePage(newPage, type, order) {
        setPage(newPage);
        if (type == "add") {
            setOrders(prevOrders => [order, ...prevOrders]);
        } else if (type == "edit") {
            setOrders(prevOrders => prevOrders.map(prevOrder =>
                prevOrder.id === order.id ? order : prevOrder
            ));
        } else if (type == "delete") {
            setOrders(prevOrders => prevOrders?.filter(prevOrder => prevOrder.id !== order));
        }
    }

    async function goToPreviousPage() {
        if (pageOrder <= 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Đây là trang đầu',
                showConfirmButton: false,
                timer: 1000
            });
            return;
        }

        setShowLoadTruoc(true);
        setPageOrder(pageOrder - 1);
    }

    async function goToNextPage() {
        setShowLoadSau(true);
        setPageOrder(pageOrder + 1);
    }

    return (
        <div className="content">
            {
                page == "detail"
                    ?
                    <>
                        {back()}
                        <OrderDetail data={dataProps} />
                    </>
                    :
                    page == "create"
                        ?
                        <>
                            {back()}
                            <OrderCreate changePage={changePage} />
                        </>
                        :
                        page == "extend"
                            ?
                            <>
                                {back()}
                                <OrderExtend changePage={changePage} />
                            </>
                            :
                            <div className="card" style={{ borderRadius: "30px", padding: "15px" }}>
                                <CardHeader>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                                        <Label
                                            style={{
                                                fontSize: '24px',
                                                color: 'DimGray',
                                                fontWeight: 'bold',
                                                margin: 0,
                                                width: "100%",
                                                textAlign: "center",
                                                marginBottom: "15px"
                                            }}
                                            className="d-block d-md-none"
                                        >
                                            <i className="fas fa-receipt" style={{ marginRight: '8px' }}></i> Danh sách đơn hàng
                                        </Label>
                                        <Label
                                            style={{
                                                fontSize: '24px',
                                                color: 'DimGray',
                                                fontWeight: 'bold',
                                                margin: 0
                                            }}
                                            className="d-none d-md-block"
                                        >
                                            <i className="fas fa-receipt" style={{ marginRight: '8px' }}></i> Danh sách đơn hàng
                                        </Label>
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <div style={{
                                                width: "200px",
                                                display: "flex",
                                                alignItems: "center"
                                            }}>
                                                <Input
                                                    style={{
                                                        borderTopLeftRadius: "30px",
                                                        borderBottomLeftRadius: "30px",
                                                        borderTopRightRadius: "0",
                                                        borderBottomRightRadius: "0",
                                                        padding: "10px 15px",
                                                        height: "35px",
                                                        margin: "0px"
                                                    }}
                                                    value={search}
                                                    onChange={(e) => searchSpace(e)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleSearch();
                                                        }
                                                    }}
                                                    placeholder="Tìm kiếm"
                                                />
                                                <Button
                                                    color="primary"
                                                    onClick={handleSearch}
                                                    style={{
                                                        borderTopRightRadius: "30px",
                                                        borderBottomRightRadius: "30px",
                                                        borderTopLeftRadius: "0",
                                                        borderBottomLeftRadius: "0",
                                                        height: "35px",
                                                        margin: "0px"
                                                    }}
                                                >
                                                    <i className="fas fa-search"></i>
                                                </Button>
                                            </div>
                                            <Button
                                                color="info"
                                                onClick={() => fetchOrders(pageOrder)}
                                                disabled={isLoading}
                                                style={{
                                                    borderRadius: "20px",
                                                    height: "35px",
                                                    padding: "0 15px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    whiteSpace: "nowrap",
                                                    flexShrink: 0
                                                }}
                                            >
                                                <i className={`fas fa-sync-alt${isLoading ? ' fa-spin' : ''}`}></i> Tải lại
                                            </Button>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody >
                                    {isLoading ? renderLoading() : table()}
                                </CardBody>
                                <CardFooter>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="page-info">
                                            <span className="text-primary font-weight-bold" style={{ fontSize: "16px" }}>
                                                Trang {pageOrder}
                                            </span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <Button
                                                style={{ marginRight: "10px", borderRadius: "30px" }}
                                                color="info"
                                                onClick={goToPreviousPage}
                                                disabled={showLoadTruoc || pageOrder <= 1 || isLoading}
                                            >
                                                {showLoadTruoc ?
                                                    <span className="spinner-border spinner-border-sm"></span> :
                                                    <> &laquo; Trang trước </>
                                                }
                                            </Button>
                                            <Button
                                                color="info"
                                                style={{ borderRadius: "30px" }}
                                                onClick={goToNextPage}
                                                disabled={showLoadSau || isLoading}
                                            >
                                                {showLoadSau ?
                                                    <span className="spinner-border spinner-border-sm"></span> :
                                                    <> Trang sau &raquo; </>
                                                }
                                            </Button>
                                        </div>
                                    </div>
                                </CardFooter>
                            </div>
            }
        </div>
    )
}

export default Orders